// Layout · Stack gap scale
//
// The closed `Gap` enum and its px lookup, shared by Stack / Inline / Grid.
// Split out of `Stack.tsx` so that module exports components only.

import { SPACE } from "@ds/tokens/palette";

export type Gap = "none" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl";

export const GAP_TO_SPACE: Record<Gap, number> = {
  none: 0,
  xs:   SPACE.xs,
  sm:   SPACE.sm,
  md:   SPACE.md,
  lg:   SPACE.lg,
  xl:   SPACE.xl,
  xxl:  SPACE.xxl,
};
